import { render } from "./Rettungspunkt.vue?vue&type=template&id=ce0b547e&scoped=true"
import script from "./Rettungspunkt.vue?vue&type=script&lang=js"
export * from "./Rettungspunkt.vue?vue&type=script&lang=js"

import "./Rettungspunkt.vue?vue&type=style&index=0&id=ce0b547e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce0b547e"]])

export default __exports__